import { Price } from '@/root/shared-types/dto/SailPricing'
import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'
import { getPriceCategoryAttribute } from '@/root/modules/shared/SelectTicketPage/helpers/priceCategoryAttribute/priceCategoryAttribute'

const TICKET_TYPE_ATTRIBUTE = 'TICKET_TYPE'

export const TicketType = {
  FULL_PRICE: 'FULL_PRICE',
  DISCOUNT_PRICE: 'DISCOUNT_PRICE',
} as const

const TICKET_TYPE_DESCRIPTION_KEYS: Record<string, Key> = {
  [TicketType.DISCOUNT_PRICE]: 'selectDiscountTicketsDescription',
}

export const getTicketDescriptionKey = (priceCategory: Price['priceCategory']): Key => {
  const value = getPriceCategoryAttribute(priceCategory, TICKET_TYPE_ATTRIBUTE)

  return (typeof value === 'string' ? TICKET_TYPE_DESCRIPTION_KEYS[value] : undefined) ?? 'selectTicketsDescription'
}
